module.exports = __webpack_public_path__ + "img/balloon_left.f6e09634.png";